import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, CheckboxStates } from "src/common";
import { Checkbox } from "src/components";

type AllProps = {
  group_name: string;
  selected: boolean;
  handleAction: ActionHandlerFunction;
};

// Description: ListRowComponent is a React component that renders a single row in the user groups list view.
// It includes a checkbox for selection and the group name, and handles click events to show the side navigation menu with group details.
function ListRowComponent(props: AllProps) {
  const { group_name, handleAction, selected } = props;

  // Description: show side nav with the email group details
  function handleRowClick() {
    handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu, params: { group_name } });
  }

  return <Row onClick={handleRowClick}>
    <Col md="1">
      <Checkbox
        className="sr-only"
        onChange={(e: FocusEvent<HTMLInputElement>) => { handleAction({ actionType: AdminUIActionTypes.Select, params: { id: group_name, selected: e.target.checked } }); }}
        selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
        value="all" label="Select All" />
    </Col>
    <Col md="5" className="col">{group_name}</Col>
  </Row>;
}

export default React.memo(ListRowComponent); 
